import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {
  catchError,
  switchMap,
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { whiteListUrls } from './whitelist-urls';
import { HttpStatus } from '@viso/core/enums';
import { IonicUtilityService } from '@viso/core/utilities';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService {
  constructor(
    private auth: AuthService,
    private router: Router,
    private ionic: IonicUtilityService
  ) {}

  // Check expiry of token, first decode token
  // extract data, and verify expiry timing wrt currentTime
  // should be less that currentTime
  private isTokenExpired() {
    const expiresAt = this.auth.getExpiry();
    const valueExist = expiresAt !== 'null' && expiresAt !== 'undefined';
    return valueExist
      ? Date.now() >= new Date(+expiresAt * 1000).getTime()
      : false;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
    | any
  > {
    const token = this.auth.getAccessToken();
    const refresh_token = this.auth.getAccessToken();
    const isExpired = this.isTokenExpired();
    // Directly allowed whitelisted URL's
    if (whiteListUrls.find((w) => request.url.includes(w))) {
      return next.handle(request);
    }
    // If accessToken is expired
    if (isExpired) {
      // Retreive new refresh_token
      const refreshToken = this.auth.refreshToken(refresh_token).pipe(
        // Applying catchError only to refreshToken call
        catchError((_) => {
          // Logout if refresh call fails
          return this.logout() as any;
        }),
        switchMap((user: any) => {
          // when new user token retrieved
          if (user) {
            // Update token locally
            this.auth.updateTokens(user);
            // Make the ajax call after by passing `accessToken`
            return next.handle(
              this.addTokenToRequest(request, user.accessToken)
            );
          }
          // Log out if there is no user
          return this.logout() as any;
        })
      );
      return refreshToken as any;
    } else {
      // Make normal ajax call just by passing token
      return next.handle(this.addTokenToRequest(request, token)).pipe(
        catchError((error) => {
          this.ionic.showToast(error?.error?.msg || 'Something went wrong.');
          if (error.status === HttpStatus.UNAUTHORIZED) {
            this.logout();
          }
          return throwError(error);
        })
      );
    }
  }

  private addTokenToRequest(
    request: HttpRequest<any>,
    token: string
  ): HttpRequest<any> {
    // Token appended in the request header.
    return request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }

  private logout() {
    this.auth.logout();
    this.router.navigateByUrl('/welcome');
  }
}
